import axios from "axios";
import { useCallback } from "react";
import { useSafeConfigSlice } from "../../packages/config/safe-config";
import type { OAuthResource } from "./index.enum";
import type { GetOAuthTokenResponse } from "./index.types";

const useOAuthService = () => {
	const { REACT_APP_EOS_OAUTH_API_ENDPOINT } = useSafeConfigSlice([
		"REACT_APP_EOS_OAUTH_API_ENDPOINT",
	]);

	const request = axios.create();

	const findOAuthToken = useCallback(
		async (path: OAuthResource) => {
			const response = await request.post<GetOAuthTokenResponse>(
				REACT_APP_EOS_OAUTH_API_ENDPOINT,
				{ resource: path },
			);
			return response.data.body.data.AccessToken;
		},
		[REACT_APP_EOS_OAUTH_API_ENDPOINT, request],
	);

	return {
		findOAuthToken,
	};
};

export default useOAuthService;
